import { BaseField, ArrayFieldGroup, BaseRecord, TemplateDoc, FieldOverride } from '../types/geneva-schema';
import * as SharedGenevaFunctions from '../../../shared/geneva-functions';

/**
 * Groups fields that belong to array structures
 * Re-exported from shared module for compatibility
 */
export const groupArrayFields = SharedGenevaFunctions.groupArrayFields;

/**
 * Identifies if a field belongs to an array structure
 * Re-exported from shared module for compatibility
 */
export const getArrayFieldInfo = SharedGenevaFunctions.getArrayFieldInfo;

/**
 * Separates regular fields from array fields in a record
 * Re-exported from shared module for compatibility
 */
export const separateArrayFields = SharedGenevaFunctions.separateArrayFields;

/**
 * Creates a default array item with empty values for all fields in the group
 * Re-exported from shared module for compatibility
 */
export const createDefaultArrayItem = SharedGenevaFunctions.createDefaultArrayItem;

/**
 * Validates array item data
 * Re-exported from shared module for compatibility
 */
export const validateArrayItem = SharedGenevaFunctions.validateArrayItem;

/**
 * Safe expression evaluator for validation and computed fields
 * Re-exported from shared module for compatibility
 */
export const safeEvaluateExpression = SharedGenevaFunctions.safeEvaluateExpression;
export const validateRecordData = SharedGenevaFunctions.validateRecordData;
export const validateMultiRecordData = SharedGenevaFunctions.validateMultiRecordData;

/**
 * Recursively resolves field overrides for a record, following the inheritance chain
 * Re-exported from shared module for compatibility
 */
export const resolveFieldOverridesRecursively = SharedGenevaFunctions.resolveFieldOverridesRecursively;

/**
 * Recursively resolves field overrides for a multi-record configuration, handling inheritance
 * Re-exported from shared module for compatibility
 */
export const resolveMultiRecordFieldOverrides = SharedGenevaFunctions.resolveMultiRecordFieldOverrides;

/**
 * Gets the full inheritance chain for a record
 * Re-exported from shared module for compatibility
 */
export const getInheritanceChain = SharedGenevaFunctions.getInheritanceChain;

/**
 * Checks if a record exists
 * Re-exported from shared module for compatibility
 */
export const recordExists = SharedGenevaFunctions.recordExists;

/**
 * Generates a complete Geneva XML-ready object with all defaults and computed values applied
 * Re-exported from shared module for compatibility
 */
export const generateCompleteGenevaObject = SharedGenevaFunctions.generateCompleteGenevaObject;

/**
 * Generates an array of complete Geneva objects for bulk requests
 * Re-exported from shared module for compatibility
 */
export const generateBulkGenevaObjects = SharedGenevaFunctions.generateBulkGenevaObjects;

/**
 * Creates record scopes for multi-record forms to enable cross-record field references
 * Re-exported from shared module for compatibility
 */
export const createRecordScopes = SharedGenevaFunctions.createRecordScopes;

